import axios from 'axios';
import LazyLoadImage from './lazyloadimage';
import * as Helper from '../helpers/helper';
import {getCurrentLang} from '../helpers/helper';
import Regions, {hasCantons} from "../helpers/regions";

export default class FilterParamsManager {
    constructor() {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        if(document.getElementsByClassName('search-page')[0]) {
            this.initElements();
            this.initEvents();
            this.pushSearchGTM();
        }
    }

    updateData() {

    }

    pushSearchGTM() {}

    initElements() {
        this.resetingFlag = false;
        const url = new URL(window.location.href);
        this.params = url.searchParams;
        this.queryParams = new URLSearchParams(window.location.search);
        this.page = this.params.get('page') || 1;
        this.reloadData = true;
        this.blockLocObserverOnetime = false;
        this.lazyLoading = new LazyLoadImage();
        this.loader = false;
        this.hasMore = window['HAS_MORE'];
        this.dataWrapper = document.getElementById('data-wrapper');

        this.selectGenres = document.getElementById('select-genre');
        this.selectGenresFOption = this.selectGenres.querySelector('.custom-options');
        this.selectSort = document.querySelector('#select-sort');
        this.selectSortFOption = this.selectSort.querySelector('.custom-options');
        this.selectLoc = document.querySelector('#select-loc');
        this.selectLocOptions = this.selectLoc.querySelector('.custom-options');

        this.datePicker = Helper.getDatePicker();
        this.dateInput = document.getElementById('date-input');
        this.ikeLoader = document.getElementById('ike-loader');
        this.resetFiltersButton = document.getElementById('reset-filters-button');
        this.freeCheckbox = document.getElementById('free');

        this.mapContainer = document.querySelector('.map-container');
        this.cancellationTokens = [];
        this.isSpecificSearchPage = false;

        this.locParam = hasCantons() ? 'canton' : 'commune';
    }

    initEvents() {
        if(document.getElementsByClassName('search-page')[0]) {
            this.setDefaultParams();

            window.addEventListener('scroll',() => {
                if (!this.loader && this.hasMore && !document.getElementsByClassName('smallEventWrapper')[0]) {
                    if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - document.querySelector('footer').offsetHeight - 400) {
                        this.loader = setTimeout(() => {
                            this.page++;
                            this.reloadData = false;
                            this.setParams();
                            this.updateData();
                        }, 100);
                    }
                }
            });

            const filterChanged = () => {
                this.page = 1;
                this.setParams();
                this.reloadData = true;
                this.updateData();
                this.resetFiltersButton.style.display = 'block';
            }

            this.selectGenresFOption.addEventListener('click', () => {
                if(!this.resetingFlag) {
                    filterChanged();
                }
            })

            this.selectSortFOption.addEventListener('click', () => {
                if(!this.resetingFlag) {
                    filterChanged();
                    if (this.params.get('sort') === 'virtual') {
                        document.getElementsByClassName('map-toggle-btn')[0].style.display = 'none';
                    } else {
                        document.getElementsByClassName('map-toggle-btn')[0].style.display = 'flex';
                    }
                }
            })

            this.selectLocOptions.addEventListener('click', () => {
                if(!this.resetingFlag && !this.blockLocObserverOnetime) {
                    this.params.delete('b_lng');
                    this.params.delete('b_lat');
                    this.params.delete('t_lng');
                    this.params.delete('t_lat');
                    filterChanged();
                }
                if(this.blockLocObserverOnetime){
                    this.blockLocObserverOnetime = false;
                }
            })

            this.datePicker.on('select', () => {
                if (this.dateInput.value && this.params.get('dates') !== this.dateInput.value) {
                    this.params.delete('time_period');
                    this.queryParams.delete('time_period');
                    this.page = 1;
                    this.setParams(true);
                    this.reloadData = true;
                    this.updateData();
                    this.resetFiltersButton.style.display = 'block';
                }
            });

            this.setupTimePeriodCards();

            this.freeCheckbox.addEventListener('change', (e) => {
                this.page = 1;
                this.setParams();
                this.reloadData = true;
                this.updateData();
            });

            this.resetFiltersButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.resetFilters(true);
            });

            var sanitizeHTML = function (str) {
              var temp = document.createElement('div');
              temp.textContent = str;
              return temp.innerHTML;
            };

            if (document.getElementsByClassName('search-input')[0]) {
                document.getElementsByClassName('search-input')[0].value = this.queryParams.get('q');
            }

            // Submit text search
            document.getElementsByClassName('search-bar')[0].addEventListener('submit', (event) => {
                event.preventDefault();

                this.queryParams.delete('q');
                let term = sanitizeHTML(document.getElementsByClassName('search-input')[0].value);
                if (term) {
                    document.getElementsByClassName('search-result-title')[0].innerHTML = `<span>${window.jsTranslations['search_result_message']} </span> ${term}`;
                    this.resetFiltersButton.style.display = 'block';
                } else {
                    document.getElementsByClassName('search-result-title')[0].innerHTML = `${window.jsTranslations['events']}`;
                    if (this.queryParams.toString() === '') {
                        this.resetFiltersButton.style.display = 'none';
                    }
                }

                this.loader = setTimeout(() => this.loader = null, 1000);
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                document.documentElement.style.scrollBehavior = 'smooth';

                this.params.set('q', term);
                this.queryParams.set('q', term);
                this.page = 1;
                this.setParams();
                this.reloadData = true;
                this.updateData();
            });

            // if no-result
            if (document.getElementsByClassName('search-no-result')[0]) {
                const resetButton = document.getElementById('reset-all-button');
                resetButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.getElementsByClassName('search-input')[0].value = '';
                    this.resetFilters(true);
                }, {once: true});
            }
        }
    }

    /**
     * Reset filters + reload events
     */
    resetFilters(resetQuery = false) {
        this.resetingFlag = true;
        const url = new URL(window.location.href);
        this.params = url.searchParams;

        this.page = 1;

        if (resetQuery) {
            this.params.delete('q');
            this.queryParams.delete('q');
            const searchTitle = document.getElementsByClassName('search-result-title')[0];
            const searchSuggest = document.getElementsByClassName('search-suggest-title')[0];
            if(searchTitle) { //Reset search input
                searchTitle.innerHTML = `${window.jsTranslations['events']}`;
            }
            if(searchSuggest) { //Hide search suggestion
                searchSuggest.innerHTML = '';
            }
        }

        // reset locations, genres and sort filters
        this.selectLoc.querySelector('.selected')?.classList.remove('selected');
        this.selectLoc.querySelector('.custom-option.default').click();
        this.selectGenres.querySelector('.selected')?.classList.remove('selected');
        this.selectGenres.querySelector('.custom-option.default').click();

        this.selectSort.querySelector('.selected')?.classList.remove('selected');
        this.selectSort.querySelector('.custom-option.default').click();

        if (document.getElementsByClassName('search-input').length > 0) {
            document.getElementsByClassName('search-input')[0].value = this.queryParams.get('q');
        }

        this.freeCheckbox.checked = false;

        this.params.delete('free');
        this.params.delete(this.locParam);
        this.selectSort.value = 'sort-by';
        this.params.delete('genre');
        this.params.delete('dates');
        this.params.delete('time_period');

        this.resetFiltersButton.style.display = 'none';

        document.getElementById('date-filter').classList.remove('checked');
        document.querySelector('#select-genre .custom-select__trigger').classList.remove('checked');
        document.querySelector('#select-sort .custom-select__trigger').classList.remove('checked');
        document.querySelector('#select-loc .custom-select__trigger').classList.remove('checked');

        document.getElementById('reset-filters-button').style.display = 'none';
        this.dateInput.placeholder = window.jsTranslations['Dates'];
        this.dateInput.value = null;

        this.queryParams.delete('free');
        this.queryParams.delete('dates');
        this.queryParams.delete('genre');
        this.queryParams.delete('sort');
        this.queryParams.delete(this.locParam);
        this.queryParams.delete('time_period');

        this.updateData();

        // Replace current querystring with the new one.
        const params = this.queryParams.toString();
        const newUrl = window.portal_conf.SEARCH_URI + (params ? ('?' + params) : '');
        try{history.replaceState(null, null, newUrl);}catch(e){console.error(e)}
        this.resetingFlag = false;

        //Fix bug where time period card would stay selected even when no time period
        // (because selection is based on the url, so it needs to be run after the change)
        Helper.getDatePicker().clear();
    }

    setParams(removeInterval = false) {
        this.params.set('page', this.page);

        const easypickWrapper = document.querySelector('.easepick-wrapper')
        if (this.dateInput.value) {
            document.getElementById('date-filter').classList.add('checked');
            this.params.set('dates', this.dateInput.value);
        }

        let periodSearchSelected = null;
        if (!removeInterval && easypickWrapper && easypickWrapper.shadowRoot.querySelector('.period-search-selected')) {
            periodSearchSelected = easypickWrapper.shadowRoot.querySelector('.period-search-selected');
            if (periodSearchSelected) {
                const startDate = periodSearchSelected.getAttribute('period-search-start');
                const endDate = periodSearchSelected.getAttribute('period-search-end');
                const title = periodSearchSelected.getAttribute('data-title');
                const slug = periodSearchSelected.getAttribute('data-slug');
                const datesSelected = `${startDate} ⟶ ${endDate}`;
                this.dateInput.setAttribute('placeholder', title);
                this.params.set('time_period', slug);
                this.params.set('dates', datesSelected);
                document.getElementById('date-filter').classList.add('checked');
            }
        }

        if (this.params.get('dates')) {
            if (!this.params.get('time_period')) {
                this.queryParams.set('dates', this.params.get('dates'));
            } else {
                this.queryParams.delete('dates');
            }
        }

        let genreValue = this.selectGenres.querySelector('.selected')?.getAttribute('data-value');
        if (genreValue != null) {
            document.querySelector('#select-genre .custom-select__trigger').classList.add('checked');
            this.params.set('genre', genreValue);
            if (!this.isSpecificSearchPage) {
                this.queryParams.set('genre', this.params.get('genre'));
            }
        } else {
            this.params.delete('genre');
            this.queryParams.delete('genre');
        }

        if (this.params.get('time_period')) {
            this.selectSort.parentElement.style.display = 'none';
        } else {
            this.selectSort.parentElement.style.display = 'block';
        }

        if (this.params.get('time_period') && this.selectLoc.querySelector('.selected') === null) {
            const selectedOption = this.selectLoc.querySelector('[data-value="near"]');
            selectedOption.classList.add('selected');
            this.selectLoc.querySelector('.custom-select__placeholder').innerHTML = selectedOption.innerHTML;
        }

        let locValue = this.selectLoc.querySelector('.selected')?.getAttribute('data-value');
        if (locValue != null) {
            document.querySelector('#select-loc .custom-select__trigger').classList.add('checked');
            this.params.set(this.locParam, locValue);
            if (!this.isSpecificSearchPage) {
                this.queryParams.set(this.locParam, this.params.get(this.locParam));
            } else {
                this.queryParams.delete(this.locParam);
            }
        } else {
            this.params.delete(this.locParam);
            this.queryParams.delete(this.locParam);
        }

        let sortValue = this.selectSort.querySelector('.selected')?.getAttribute('data-value');
        if (sortValue != null) {
            document.querySelector('#select-sort .custom-select__trigger').classList.add('checked');
            this.params.set('sort', sortValue);
            this.queryParams.set('sort', this.params.get('sort'));
        } else {
            this.params.delete('sort');
            this.queryParams.delete('sort');
        }

        if (this.freeCheckbox.checked) {
            this.params.set('free', 1);
            this.queryParams.set('free', this.params.get('free'));
        } else {
            this.params.delete('free');
            this.queryParams.delete('free');
        }

        if (!this.mapContainer.classList.contains('open')) {
            this.params.delete('b_lng');
            this.params.delete('b_lat');
            this.params.delete('t_lng');
            this.params.delete('t_lat');
            this.params.delete('mode_map');
        }

        const url = new URL(window.location.href);
        genreValue = this.selectGenres.querySelector('.selected')?.getAttribute('data-slug');
        if (locValue === 'near') {
            this.queryParams.set(this.locParam, this.params.get(this.locParam));
            locValue = null;
        } else {
            locValue = this.selectLoc.querySelector('.selected')?.getAttribute('data-slug');
        }

        let timePeriodValue = null;
        if (periodSearchSelected) {
            timePeriodValue = periodSearchSelected.getAttribute('data-slug');
            this.params.set('time_period', timePeriodValue);
            this.queryParams.set('time_period', this.params.get('time_period'));
            this.resetFiltersButton.style.display = 'block';
        }

        if (genreValue || locValue || timePeriodValue && !removeInterval) {
            url.pathname = '/' + getCurrentLang() + (genreValue ? '/' + genreValue : '') + (locValue ? '/' + locValue : '') + (timePeriodValue && !removeInterval ? '/' + timePeriodValue : '');
        } else {
            url.href = window.portal_conf.SEARCH_URI;
        }

        if (!this.isSpecificSearchPage && (this.params.get(this.locParam) || this.params.get('genre') || this.params.get('time_period'))) {
            this.queryParams.delete(this.locParam);
            this.queryParams.delete('genre');
            this.queryParams.delete('time_period');
            url.searchParams.forEach((value, key) => {
                const _value = this.queryParams.get(key);
                if (_value) {
                    url.searchParams.set(key, _value);
                } else {
                    url.searchParams.delete(key);
                }
            });
        }

        if (this.queryParams.get('q')) {
            url.searchParams.set('q', this.queryParams.get('q'));
        }
        url.searchParams.forEach((value, key) => {
            const _value = this.queryParams.get(key);
            if (_value) {
                url.searchParams.set(key, _value);
            } else {
                url.searchParams.delete(key);
            }
        });

        if (this.params.get(this.locParam)) {
            this.queryParams.delete(this.locParam);
        }
        if (this.params.get('genre')) {
            this.queryParams.delete('genre');
        }
        if (this.params.get('time_period')) {
            this.queryParams.delete('time_period');
        }

        const params = this.queryParams.toString();
        url.search = params ? '?' + params : '';
        try{history.replaceState(null, null, url);}catch(e){console.error(e)}

        this.isSpecificSearchPage = !!((this.params.get(this.locParam) && this.params.get('canton') !== 'near') || this.params.get('genre') || this.params.get('time_period'));
        if (this.params.get('sort') !== 'virtual' && !this.mapContainer.classList.contains('open')) {
            document.getElementById('select-loc').parentElement.classList.remove('hidden');
            document.querySelectorAll('.display-map').forEach(function(element) {
                element.classList.remove('hidden');
            });
        } else {
            document.getElementById('select-loc').parentElement.classList.add('hidden');
            this.queryParams.delete(this.locParam);
            this.params.delete(this.locParam);
        }
    }

    setupTimePeriodCards() {
        const easypickWrapper = document.querySelector('.easepick-wrapper').shadowRoot;
        if (easypickWrapper) {
            document.addEventListener('timePeriodCardSelected', (e) => {
                e.preventDefault();
                this.datePicker.clear();
                const selectedCard = easypickWrapper.querySelector('.time-period-card-'+e.detail.slug);
                easypickWrapper.querySelector('.period-search-selected')?.classList.remove('period-search-selected');
                selectedCard?.classList.add('period-search-selected');
                this.setParams();
                this.updateData();
            });
        }
    }

    /**
     * Init data from url query params
     */
    setDefaultParams(setParams = true) {
        if (this.params.get('q')) {
            this.resetFiltersButton.style.display = 'block';
        }

        if (this.params.get('dates')) {
            document.getElementById('date-filter').classList.add('checked');

            this.resetFiltersButton.style.display = 'block';
            this.dateInput.placeholder = this.params.get('dates');
        }

        const baseGenre = this.selectGenres.querySelector('.selected')?.getAttribute('data-value');
        if (this.params.get('genre') || baseGenre) {
            if (baseGenre) {
                this.params.set('genre', baseGenre);
            }
            this.resetFiltersButton.style.display = 'block';

            let currentGenre = baseGenre || this.params.get('genre');

            for(let option of this.selectGenres.querySelectorAll('.custom-option')) {
                option.classList.remove('selected');
                if(option.getAttribute('data-value') === currentGenre) {
                    option.classList.add('selected');
                    this.selectGenres.querySelector('.custom-select__placeholder').innerHTML = option.innerHTML;
                }
            }
        }

        const baseLocation = this.selectLoc.querySelector('.selected')?.getAttribute('data-value');
        if (this.params.get(this.locParam) || baseLocation) {
            if (baseLocation) {
                this.params.set(this.locParam, baseLocation);
            }
            this.resetFiltersButton.style.display = 'block';

            let currentLocation = baseLocation || this.params.get('canton');

            for(let option of this.selectLoc.querySelectorAll('.custom-option')) {
                option.classList.remove('selected');
                if(option.getAttribute('data-value') === currentLocation) {
                    option.classList.add('selected');
                    this.selectLoc.querySelector('.custom-select__placeholder').innerHTML = option.innerHTML;
                }
            }
        }

        if (this.params.get('sort')) {
            this.resetFiltersButton.style.display = 'block';

            let currentSort = this.params.get('sort');

            for(let option of this.selectSort.querySelectorAll('.custom-option')) {
                option.classList.remove('selected');
                if(option.getAttribute('data-value') == currentSort) {
                    option.classList.add('selected');
                    this.selectSort.querySelector('.custom-select__placeholder').innerHTML = option.innerHTML;
                }
            }
        }

        if (this.params.get('free')) {
            this.freeCheckbox.checked = this.params.get('free');

            if (!this.params.has('free') || this.params.get('free') === '1') {
                this.freeCheckbox.checked = 1;
            } else {
                this.freeCheckbox.checked = 0;
            }
        }

        if (document.querySelector('.easepick-wrapper').shadowRoot.querySelector('.period-search-selected')) {
            this.resetFiltersButton.style.display = 'block';
        }

        this.isSpecificSearchPage = !!(this.params.get(this.locParam) || this.params.get('genre') || this.params.get('time_period'));

        setParams && this.setParams();
    }
}
